// src/data/demoUsers.js
export const DEMO_USERS = [
  {
    id: "u1",
    name: "Alex Rivera",
    handle: "@alex",
    avatar: "https://picsum.photos/seed/u1/200/200",
    banner: "https://picsum.photos/seed/u1b/1600/700",
    bio: "Filmmaker • Editor • Traveler.",
    stats: { followers: 1280, following: 342, createdVideos: 9, createdImages: 9, purchasedVideos: 24, purchasedImages: 24, watchlist: 24 },
  },
  {
    id: "u2",
    name: "Sam Chen",
    handle: "@samchen",
    avatar: "https://picsum.photos/seed/u2/200/200",
    banner: "https://picsum.photos/seed/u2b/1600/700",
    bio: "MicroNFT tinkerer. Coffee-powered.",
    stats: { followers: 420, following: 180, createdVideos: 12, createdImages: 7, purchasedVideos: 8, purchasedImages: 5, watchlist: 12 },
  },
  {
    id: "u3",
    name: "Priya Patel",
    handle: "@priya",
    avatar: "https://picsum.photos/seed/u3/200/200",
    banner: "https://picsum.photos/seed/u3b/1600/700",
    bio: "Photographer • Art lover.",
    stats: { followers: 980, following: 220, createdVideos: 4, createdImages: 15, purchasedVideos: 3, purchasedImages: 19, watchlist: 33 },
  },
  {
    id: "u4",
    name: "Diego Márquez",
    handle: "@diegom",
    avatar: "https://picsum.photos/seed/u4/200/200",
    banner: "https://picsum.photos/seed/u4b/1600/700",
    bio: "Motion graphics + VJ sets.",
    stats: { followers: 650, following: 410, createdVideos: 20, createdImages: 2, purchasedVideos: 2, purchasedImages: 8, watchlist: 14 },
  },
  {
    id: "u5",
    name: "Aya Nakamura",
    handle: "@ayan",
    avatar: "https://picsum.photos/seed/u5/200/200",
    banner: "https://picsum.photos/seed/u5b/1600/700",
    bio: "Light, color, texture.",
    stats: { followers: 1510, following: 120, createdVideos: 6, createdImages: 22, purchasedVideos: 4, purchasedImages: 30, watchlist: 28 },
  },
];

// simple mock graph: u1 follows u2,u3,u4 and is followed by u3,u4,u5
export const DEMO_FOLLOWS = {
  u1: { followers: ["u3", "u4", "u5"], following: ["u2", "u3", "u4"] },
  u2: { followers: ["u1"], following: ["u3"] },
  u3: { followers: ["u1"], following: ["u1", "u2"] },
  u4: { followers: ["u1"], following: ["u1"] },
  u5: { followers: ["u1"], following: [] },
};

export function getUserById(id) {
  return DEMO_USERS.find((u) => u.id === id);
}
export function getPeople(ids = []) {
  return ids.map(getUserById).filter(Boolean);
}
export function getFollowers(userId) {
  return getPeople(DEMO_FOLLOWS[userId]?.followers || []);
}
export function getFollowing(userId) {
  return getPeople(DEMO_FOLLOWS[userId]?.following || []);
}
